import React from 'react';
import { BrowserRouter as Router, Routes, Route, HashRouter } from 'react-router-dom';
import ForgotPassword from './components/PasswordChange/olvideContrasena';
import PasswordChange from './components/PasswordChange/PasswordChange';
import NotFoundPage from './components/PasswordChange/NotFoundPage';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'; 


function App() {
  return (
    <div className="App">
    <HashRouter>
      <div className="min-w-7xl">
        <Routes>
          <Route path="/forgot-password/:ambiente" element={
              <GoogleReCaptchaProvider
                reCaptchaKey="6LddzEMpAAAAAEXnAAr46YeKOrozGA0oJdPD7yAq"
                scriptProps={{
                  async: true,
                  defer: true,
                  appendTo: "head",
                  nonce: undefined,
                }}
              >
                <ForgotPassword />
              </GoogleReCaptchaProvider>
            }/>
          <Route path="/reset-password/:ambiente/:token" element={<PasswordChange />} />
          <Route path="/404" element={<NotFoundPage />} />
        </Routes>    
      </div>
    </HashRouter>
  </div>
  );
}

export default App;